export const openCentralizedPopupWindow = (
  url: string,
  windowName: string,
  width: number = 500,
  height: number = 800
): WindowProxy | null => {
  // Fixes dual-screen position Most browsers Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const clientWidth =
    window.innerWidth || document.documentElement.clientWidth || screen.width;
  const clientHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    screen.height;

  const left = (clientWidth - width) / 2 + dualScreenLeft;
  const top = (clientHeight - height) / 2 + dualScreenTop;

  return window.open(
    url,
    windowName,
    `width=${width},height=${height},left=${left},top=${top}`
  );
};

export const onWindowPopupCloseRefresh = (
  newWindow: Window,
  newHref?: string
) => {
  const timer = setInterval(function() {
    if (newWindow.closed) {
      // Stop polling as soon as the popup is gone, regardless of what we can
      // read from it — otherwise a throwing/blocked read leaks the interval.
      clearInterval(timer);

      if (newHref) {
        window.location.href = newHref;
        return;
      }

      try {
        // No explicit target: fall back to the popup's final URL. Once closed
        // this is normally same-origin, but guard in case the browser blocks it.
        window.location.href = newWindow.location.href;
      } catch (e) {
        // Nothing readable from the closed popup and no target — stay put.
      }
    }
  }, 1000);
};

export const closeOnWindowPopupUrlMatches = (
  newWindow: Window,
  url: string,
  newHref?: string
) => {
  const timer = setInterval(function() {
    // If the merchant closes the popup before it returns to our origin, stop
    // polling instead of looping forever on a window we can never read.
    if (newWindow.closed) {
      clearInterval(timer);
      return;
    }

    let currentHref: string;
    try {
      // Cross-origin .location.href read throws SecurityError while the popup
      // is on the provider domain; skip this tick until it returns to our origin.
      currentHref = newWindow.location.href;
    } catch (e) {
      return;
    }
    if (currentHref.includes(url)) {
      newWindow.close();
      window.location.href = newHref || currentHref;
      clearInterval(timer);
    }
  }, 1000);
};

export const onSigninPopupCloseRedirect = (newWindow: any) => {
  const timer = setInterval(function() {
    // newWindow.closed is readable cross-origin and never throws.
    if (newWindow.closed) {
      clearInterval(timer);
      return;
    }

    let connectedThoughtProvider: any;
    let connectionRedirectUrl: any;
    try {
      // Cross-origin custom property reads throw SecurityError while the popup
      // is on the provider domain; skip this tick until it returns to our origin.
      connectedThoughtProvider = newWindow.connectedThoughtProvider;
      connectionRedirectUrl = newWindow.connectionRedirectUrl;
    } catch (e) {
      return;
    }

    if (connectedThoughtProvider) {
      window.location.href = connectionRedirectUrl || window.location.href;
      newWindow.close();
      clearInterval(timer);
    }
  }, 1000);
};
